import axios from "axios";

const prepareData = (data) => {return {workshop:data}}

// Plural Actions
export const GET_WORKSHOPS = "get_workshops";
export const getWorkshops = () => {
	const url = `/workshops.json`
	const request = axios.get(url);
	return {
		type: GET_WORKSHOPS,
		payload: request
	};
};


// Singular Actions
export const CREATE_WORKSHOP = "create_workshop";
export const createWorkshop = (data) => {
	const url = `/workshops.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_WORKSHOP,
		payload: request
	};
};

export const GET_WORKSHOP = "get_workshop";
export const getWorkshop = (id) => {
	const url = `/workshops/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_WORKSHOP,
		payload: request
	};
};

export const UPDATE_WORKSHOP = "update_workshop";
export const updateWorkshop = (id,data) => {
	const url = `/workshops/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_WORKSHOP,
		payload: request
	};
};

export const DESTROY_WORKSHOP = "destroy_workshop";
export const destroyWorkshop = (id) => {
	const url = `/workshops/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_WORKSHOP,
		payload: request
	};
};
